module.exports = __webpack_public_path__ + "static/img/banner.90fb03c.png";


//////////////////
// WEBPACK FOOTER
// ./static/cooperate/banner.png
// module id = lBvy
// module chunks = 1